import { ReactNode, PureComponent } from 'react';

import { Repository } from 'src/components/types';

export type FileFetcherProps = {
  children: ReactNode;
  loadFileMeta: (repository: Repository, hash: string, path: string) => void;
  hash: string | null | undefined;
  path: string;
  repository: Repository | null | undefined;
};

export default class FileFetcher extends PureComponent<FileFetcherProps> {
  componentDidMount() {
    this.loadFileMeta();
  }

  componentDidUpdate(prevProps: FileFetcherProps) {
    const { hash, path, repository } = this.props;
    if (
      path !== prevProps.path ||
      hash !== prevProps.hash ||
      !prevProps.repository ||
      (repository && repository.uuid !== prevProps.repository.uuid)
    ) {
      this.loadFileMeta();
    }
  }

  loadFileMeta = () => {
    const { hash, path, repository } = this.props;

    if (hash && repository) {
      this.props.loadFileMeta(repository, hash, path);
    }
  };

  render = () => this.props.children || null;
}
